import { XMarkIcon, ArrowDownTrayIcon, ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import type { ClubTheme } from './themes';

interface PdfViewerModalProps {
  url: string;
  filename: string;
  theme: ClubTheme;
  onClose: () => void;
}

export default function PdfViewerModal({ url, filename, theme, onClose }: PdfViewerModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60" onClick={onClose}>
      <div
        className="relative flex h-[90vh] w-[90vw] max-w-4xl flex-col overflow-hidden rounded-2xl shadow-2xl"
        style={{ backgroundColor: theme.colors.surface }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          className="flex items-center justify-between px-4 py-3"
          style={{ borderBottom: `1px solid ${theme.colors.muted}20` }}
        >
          <h3 className="text-sm font-semibold truncate" style={{ color: theme.colors.text }}>
            {filename}
          </h3>
          <div className="flex items-center gap-2">
            <a
              href={url}
              download={filename}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-lg p-1.5 transition-colors hover:opacity-70"
              style={{ color: theme.colors.muted }}
              title="Download"
            >
              <ArrowDownTrayIcon className="h-4 w-4" />
            </a>
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-lg p-1.5 transition-colors hover:opacity-70"
              style={{ color: theme.colors.muted }}
              title="Open in new tab"
            >
              <ArrowTopRightOnSquareIcon className="h-4 w-4" />
            </a>
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg p-1.5 transition-colors hover:opacity-70"
              style={{ color: theme.colors.muted }}
            >
              <XMarkIcon className="h-5 w-5" />
            </button>
          </div>
        </div>

        {/* PDF iframe */}
        <iframe
          src={url}
          title={filename}
          className="flex-1 w-full border-0"
          style={{ backgroundColor: '#fff' }}
        />
      </div>
    </div>
  );
}
